export default (props, inject) => {
    // amount - число
    // decimalCount - сколько чисел после запятой
    // decimal - разделитель между целым и десятичным числом
    // thousands - разделитель между разрядами целого числа

    const phoneFormat = (numberPhone = '') => {
        const cleaned = (`${numberPhone}`).replace(/\D/g, '');
        const match = cleaned.match(/^(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})$/);
        const isUsePlus = Boolean(cleaned[0] === '7');

        if (match) {
            const stringArray = [match[1], ' (', match[2], ') ', match[3], ' ', match[4], '', match[5]];
            if (isUsePlus) {
                stringArray.unshift('+');
            }

            return stringArray.join('');
        }

        return numberPhone;
    };
    inject('phoneFormat', phoneFormat);
};
